export default __webpack_public_path__ + "static/comment-2c7480458e7c4fbb0e4edb98749a9cca.jpg";